import React from "react";

export function ProductCard({ product, onView, t, tr }) {
  const name = tr ? tr(product.translations, "name", product.name) : product.name;
  const desc = tr ? tr(product.translations, "description", product.description) : product.description;
  return (
    <div
      data-testid={`product-card-${product.sku}`}
      className="group bg-white rounded-3xl overflow-hidden card-hover cursor-pointer border border-sambiva-charcoal/5 flex flex-col"
      onClick={() => onView(product.slug)}
    >
      <div className="aspect-square bg-sambiva-cream overflow-hidden">
        <img
          src={product.images?.[0]}
          alt={name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
      </div>
      <div className="p-5 flex flex-col flex-1">
        <span className="text-xs font-semibold text-sambiva-green uppercase tracking-wide mb-1">
          {product.category}
        </span>
        <h3 className="font-serif text-lg text-sambiva-charcoal leading-tight mb-1">{name}</h3>
        <p className="text-sm text-sambiva-muted line-clamp-2 mb-3 flex-1">{desc}</p>
        <div className="flex items-center justify-between">
          {product.pack_size && (
            <span className="text-xs text-sambiva-muted bg-sambiva-cream px-2.5 py-1 rounded-full">
              {product.pack_size}
            </span>
          )}
          <span className="text-sm font-semibold text-sambiva-red group-hover:underline ml-auto">
            {t ? t("common.viewProduct") : "View Product"} →
          </span>
        </div>
      </div>
    </div>
  );
}
